import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
	pwa?: boolean;
	logo?: string;
} = {
	navTheme: 'light',
	// Black for light mode
	colorPrimary: '#111111',
	layout: 'top',
	contentWidth: 'Fluid',
	fixedHeader: false,
	fixSiderbar: true,
	colorWeak: false,
	title: 'Assemble | Speedcargo Technologies',
	pwa: true,
	logo: 'logo.svg',
	iconfontUrl: '',
	token: {
		// Custom token overrides for #111111 primary color
		colorPrimary: '#1F1F1F',
		borderRadius: 0,
	},
};

export default Settings;
